import React from "react";
import {toAbsoluteUrl} from "../../../_helpers";
import ButtonAction from '../../../../app/modules/_common/components/ButtonAction';

export function ScrollTop() {
  return (
    <ButtonAction
      variant={'icon'}
      iconButtonType={'primary'}
      id={'kt_scrolltop'}
      label={<img src={toAbsoluteUrl("/media/common/Up-2.svg")} alt="up"/>}
      customClassnames={'scrolltop'}
    />
  );
}
